export enum RequestResponseStatusEnum{
    PENDING = 0,
    REJECTED = 1,
    ANSWERED = 2,
    ACCEPTED = 3,
    CANCELED = 4,
    EXPIRED = 5,
    CLOSED = 5

}